
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/locations",
      function () {
        return require("private-next-pages/[slug]/locations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/locations"])
      });
    }
  